import { Context } from "@nuxt/types/app";
import XLSX from "xlsx";

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default function (context: Context) {
  // for generating excel template
  function blobExcel(
    arrData: Array<Array<string | number>>,
    props: Record<string, any>,
    headerRow = 0,
  ): Blob {
    const wb: any = XLSX.utils.book_new();
    wb.Props = Object.assign(props || {}, {
      Title: "Sheet",
      Subject: "XLSX",
      Author: "",
      CreatedDate: new Date(),
    });
    wb.SheetNames.push(wb.Props.Title);
    wb.Sheets[wb.Props.Title] = XLSX.utils.aoa_to_sheet(arrData);
    wb.Sheets[wb.Props.Title]["!cols"] = arrData[headerRow].map((col) => ({
      wch: col.toString().length,
    }));

    const wbOut = XLSX.write(wb, { bookType: "xlsx", type: "binary" });

    const buf = new ArrayBuffer(wbOut.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i < wbOut.length; i += 1) {
      // eslint-disable-next-line
            view[i] = wbOut.charCodeAt(i) & 0xFF;
    }

    return new Blob([buf], { type: "application/octet-stream" });
  }

  return {
    blobExcel,
  };
}
